export const RANGE_DASH = '–'

function paragraphNumberOf(node: Node): string | undefined {
  const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : (node as Element)
  return element?.closest('[data-avsnitt]')?.getAttribute('data-avsnitt') ?? undefined
}

function isParagraphText(node: Node): boolean {
  return Boolean(node.textContent?.trim() && node.parentElement?.closest('[data-avsnitt]'))
}

// A drag can stop at the start of the next paragraph, on a heading or on the container itself; the reader selected none of those.
export function selectedEndNode(range: Range, accepts: (node: Node) => boolean = isParagraphText): Node {
  const { endContainer, endOffset } = range
  if (range.collapsed || (endContainer.nodeType === Node.TEXT_NODE && endOffset > 0)) {
    return endContainer
  }
  const walker = document.createTreeWalker(range.commonAncestorContainer, NodeFilter.SHOW_TEXT, {
    acceptNode: node => (accepts(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
  })
  const boundary = endContainer.nodeType === Node.TEXT_NODE ? endContainer : endContainer.childNodes[endOffset]
  if (boundary) {
    walker.currentNode = boundary
    return walker.previousNode() ?? endContainer
  }
  walker.currentNode = endContainer
  return walker.lastChild() ?? endContainer
}

export function resolveParagraphRange(range: Range): string | undefined {
  const start = paragraphNumberOf(range.startContainer)
  if (!start) {
    return undefined
  }
  const end = paragraphNumberOf(selectedEndNode(range))
  return end && end !== start ? `${start}${RANGE_DASH}${end}` : start
}

export function withParagraphAnchor(url: string, paragraph?: string): string {
  if (!paragraph) {
    return url
  }
  const first = paragraph.split(RANGE_DASH)[0]
  return `${url.split('#')[0]}#avsnitt-${first}`
}
